module.exports = __webpack_public_path__ + "img/rates.98126b5b.svg";